import { render } from "./ResultSectionView.vue?vue&type=template&id=df420630"
import script from "./ResultSectionView.vue?vue&type=script&lang=js"
export * from "./ResultSectionView.vue?vue&type=script&lang=js"

import "./ResultSectionView.vue?vue&type=style&index=0&id=df420630&lang=css"

import exportComponent from "/var/www/html/bcsprostuti-web-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__